import { useStores } from "stores";
import { allRoutesItems } from "./RoutesConfig";
import { Routes, Route } from "react-router-dom";

export const RoutesList = () => {
  const { user } = useStores();

  const routesItems = allRoutesItems.filter((item) => item.roles.some((role) => user.scope.includes(role)));

  return (
    <Routes>
      {routesItems.map((item, idx) => (
        <Route key={item.path + idx} {...item} />
      ))}
    </Routes>
  );
};
